import { useRef } from 'react';

import { Box, Flex, useMultiStyleConfig } from '@chakra-ui/react';

import { TeyaseerArticleSectionProps } from './TeyaseerArticleSection.type';

import { Container, ContentfulRichText, Image, Section } from '@/components';
import { animationStyle } from '@/helpers/utils';
import useInViewport from '@/hooks/useInVewport';

const TeyaseerArticleSection = (props: TeyaseerArticleSectionProps) => {
  const { backgroundImage, mainTitle, description, id } = props;
  const style = useMultiStyleConfig('TeyaseerArticleSection', {});

  const sectionRef = useRef(null);
  const isInView = useInViewport(sectionRef);

  return (
    <Section ref={sectionRef} __css={style.root} id={id}>
      <Box
        className="bgImageContainer"
        sx={animationStyle({ type: 'blur', perform: isInView })}
      >
        <Image
          src={backgroundImage?.fields.file.url || ''}
          alt="background-image"
          className="background-image"
          fill
        />
      </Box>
      <Container>
        <Flex className="center-box">
          <Box
            sx={animationStyle({
              type: 'slideUp',
              perform: isInView,
            })}
          >
            <ContentfulRichText
              variant="unstyled"
              className="title"
              document={mainTitle}
            />
          </Box>
          <Box
            sx={{
              ...animationStyle({
                type: 'slideDown',
                perform: isInView,
              }),
              pb: '100px',
            }}
          >
            <ContentfulRichText
              variant="unstyled"
              className="action-link"
              document={description}
            />
          </Box>
        </Flex>
      </Container>
    </Section>
  );
};

export default TeyaseerArticleSection;
